export const environment = {
  PRODUCTION: false,
  API_URL: 'https://backend.hml-gcp.allya.com.br/api/',
  SITE_URL: 'https://site.hml-gcp.allya.com.br/',
  LS_SECRET: 'Mmy5WtU@$tSe',
  API_DOCUMENTATION: 'https://documenter.getpostman.com/view/13748748/TVmPBcyh',
  INVITE_URL: 'indica.hml-gcp.allya.com.br',
  PORTAL_URL: 'https://portal.hml-gcp.allya.com.br',
  CDN_IMAGES_WEB: 'https://assets.hml.allya.com.br/images/w',
  CDN_IMAGES_APP: 'https://assets.hml.allya.com.br/images/m',
  BUCKET_UPLOAD_IMAGE: 'upload-image.hml.allya.com.br',
  RECAPTCHA_KEY: '6Lch8sMmAAAAAJJta1frhl86J2dq8CsTn7PJkHlh',
  COOKIE_DOMAIN: '.hml-gcp.allya.com.br',
  COOKIE_AT: 'AT_HML',
  COOKIE_BT: 'BT_HML',
  COOKIE_BID: 'BID_HML',
  GTM_ID: 'GTM-NRTLMTXZ',
};
